/**
 * Quote — highlight / pull-quote block with a left accent bar and an optional
 * attribution line. Used by chapter 2727 for the mass-balance highlight (no
 * attribution) and the EVBox Livo case-study quote (with attribution).
 */

import type { Quote as QuoteData } from "../chapter.types";
import "./Quote.css";

interface QuoteProps {
  quote: QuoteData;
}

export const Quote = ({ quote }: QuoteProps) => {
  // Figma: the standalone highlight (no attribution) is wrapped in typographic
  // quotation marks; the attributed case-study quote is not.

  return (
    <blockquote className="cmf-quote">
      <div className="cmf-quote__symbol">“</div>
      <p className="cmf-quote__text">{quote.text}</p>
      {quote.attribution && (
        <footer className="cmf-quote__attribution">{quote.attribution}</footer>
      )}
    </blockquote>
  );
};
